import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { ThemeProvider } from 'react-jss'
import { PageProps } from './PageProps'
import pageSchema from './pageSchema'
import useDataValidation from '../../data/useDataValidation'
import Component from '../content/Component'
import useStyles from './page.styles'

const DEFAULT_TITLE_TAG = 'NEON - Watch On Demand Movies & TV Shows Online'

const Page: React.FC<PageProps> = ({ definition }: PageProps) => {
  const [validatedData, validationError] = useDataValidation(
    pageSchema,
    definition
  )
  const classes = useStyles()

  useEffect(() => {
    if (!validatedData?.pageTitle) {
      document.title = DEFAULT_TITLE_TAG
    } else {
      document.title = validatedData.pageTitle
    }
  }, [validatedData?.pageTitle])

  if (validationError) {
    return (
      <div>
        <div>Data Invalid</div>
        {validationError.details.map(({ message, context }, index) => {
          return (
            <div key={index}>
              <div>{message}</div>
              {context && <div>{context.message}</div>}
            </div>
          )
        })}
      </div>
    )
  }

  if (!validatedData) {
    return <div>No page data found</div>
  }

  const { theme, components } = definition

  return (
    <>
      <Helmet>
        {validatedData?.metadata.map((meta, index) => (
          <meta
            key={index}
            name={meta.name || undefined}
            content={meta.content}
            property={meta.property || undefined}
          />
        ))}
      </Helmet>
      <ThemeProvider theme={theme}>
        <div className={classes.container}>
          {components.map((component, index) => (
            <Component
              key={component.type + index}
              definition={component}
              index={index}
            />
          ))}
        </div>
      </ThemeProvider>
    </>
  )
}

export default Page
